import { render, staticRenderFns } from "./view2.vue?vue&type=template&id=334ad098&scoped=true"
import script from "./view2.vue?vue&type=script&lang=js"
export * from "./view2.vue?vue&type=script&lang=js"
import style0 from "./view2.vue?vue&type=style&index=0&id=334ad098&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334ad098",
  null
  
)

export default component.exports